<!-- The home's themes box for this one theme (owner 2026-10-15): app-theme-showcase without its
     themes' dock; this component keeps the state (platform, stats, the store and cart logic). -->
<div [class.expander-panel]="!inline" [class.expander-inline]="inline" *ngIf="product"
     [style.--plugin-primary]="product.designTokens?.primaryColor"
     [style.--plugin-secondary]="product.designTokens?.secondaryColor">

  <app-theme-showcase [themes]="[]"
                      [active]="active"
                      [platforms]="platforms"
                      [platformIndex]="selectedPlatformIndex"
                      [screenshot]="currentScreenshot"
                      [ctaText]="ctaText"
                      [ctaLabels]="ctaLabels"
                      [planned]="selectedPlatformPlanned"
                      [priceLabel]="selectedPriceLabel || ''"
                      [downloads]="downloads"
                      [statsLoaded]="statsLoaded"
                      [rating]="rating"
                      [siteDark]="darkModeActive"
                      (hold)="held = $event"
                      (platformPick)="selectPlatform( $event )"
                      (cta)="getSelected()">
    <!-- the box's edge round its popover shape (the clip drops its own), in the
         box's own edge colour -->
    <svg tsxOverlay class="expander-outline" *ngIf="!inline" aria-hidden="true"><path></path></svg>
  </app-theme-showcase>
</div>
